import type { RouteRecordRaw } from 'vue-router'
import { LOCAL_SERVICES } from '../config/localServices'

/** Routes /{prestation}-{ville} (ex. /creation-site-vitrine-lille) */
export const localServiceRoutes: RouteRecordRaw[] = LOCAL_SERVICES.map((svc) => ({
  path: `${svc.urlPrefix}-:citySlug`,
  name: `local-svc-${svc.id}`,
  component: () => import('../views/LocalCityView.vue'),
  meta: {
    serviceId: svc.id,
    robots: 'index,follow'
  }
}))
